<template>
  <MenuButton :btn-key="btnKey" :highlight="highlight" @click="click" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import MenuButton from '@/components/public/MenuButtons/MenuButton.vue'
import { NavButtonKeys, VisualisationTypes } from '@/types'

const components = {
  MenuButton,
}

@Component({ components })
export default class MenuButtonMap extends Vue {
  get btnKey() {
    return NavButtonKeys.NESTED_BUBBLES
  }

  get highlight() {
    return this.$typedStore.activeVisualisation.isNestedBubbles
  }

  click() {
    this.$typedStore.activeVisualisation.setActiveVisualisationType({
      appId: this.$typedStore.activeVisualisation.appId,
      visualisationType: VisualisationTypes.NESTED_BUBBLES,
    })
  }
}
</script>
